import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { toast } from 'react-toastify';
import { CreateGrouphooks, GroupGetbyIdhooks } from '../../Helper/GroupHelper';

const modules = [
    { moduleId: 1, module: 'Layout' },
    { moduleId: 2, module: 'Screen' },
     { moduleId: 3, module: 'User' },
    { moduleId: 6, module: 'Content' },
    { moduleId: 8, module: 'Permission' },
];

const moduleOptions = modules.map(mod => ({
    value: mod.moduleId,
    label: mod.module
}));

function CreateGroupByComponent(props) {
    const [selectedModule, setSelectedModule] = useState(null);
    const [groupName, setGroupName] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        if (props.id !== undefined && props.id !== null) {
            loadGroupDetails(props.id);
        }
    }, [props.id]);

    const loadGroupDetails = async (groupId) => {
        try {
            const res = await GroupGetbyIdhooks(groupId);
            if (res) {
                setGroupName(res.groupName || "");
                setDescription(res.description || "");
                const module = moduleOptions.find(mod => mod.value === res.moduleId);
                setSelectedModule(module || null);
            }
        } catch (error) {
            toast.error("Failed to load group data.");
            console.error("Group load error", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const groupdata = {
            groupId: props.id || 0,
            groupName: groupName.trim(),
            description: description.trim(),
            moduleId: selectedModule?.value || null,
            updatedBy: localStorage.getItem("userId"),
            createdBy: localStorage.getItem("userId"),
            isActive: true
        };

        if (!groupdata.groupName || !groupdata.moduleId) {
            toast.error("Group Name and Module are required.");
            return;
        }

        try {
            const res = await CreateGrouphooks(groupdata);

            if (res !== undefined) {
                toast.success('Group saved successfully!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                throw new Error("Save failed");
            }
        } catch {
            toast.error('Failed to save Group. Please try again!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    return (
        <div className="container-fluid content-top-gap">
            <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb my-breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {props.id !== undefined ? "Edit Group" : "Add Group"}
                    </li>
                </ol>
            </nav>

            <div className="row">
                <div className="col-lg-12 mb-4">
                    <div className="card card_border">
                        <div className="card-header chart-grid__header">
                            {props.id !== undefined ? "Edit Group" : "Add Group"}
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label className="input__label">Group Name</label>
                                        <input
                                            type="text"
                                            className="form-control input-style"
                                            value={groupName}
                                            onChange={(e) => setGroupName(e.target.value)}
                                            placeholder="Enter Group Name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label className="input__label">Select Module</label>
                                        <Select
                                            name="Module"
                                            value={selectedModule}
                                            options={moduleOptions}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Select Module"
                                            onChange={(e) => setSelectedModule(e)}
                                            isSearchable
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="input__label">Description</label>
                                    <input
                                        type="text"
                                        className="form-control input-style"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Enter Description"
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary btn-style mt-4">
                                    {props.id !== undefined ? "Update" : "Add"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateGroupByComponent;
